// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.demo .dialog {
    width: 600px;
    color: var(--black-65);
    background-color: var(--black-05);
    gap: 16px;
}

.modal.demo .dialog > .header {
    height: 40px;
    border-bottom: 1px solid var(--black-20);
}

.modal.demo .dialog > .body {
    font-size: 13px;
}

.modal.demo .dialog > .titlebar {
    font-size: 16px;
    color: var(--black-80);
    font-weight: bold;
}

.modal.demo .dialog .expando {
    border: 2px solid var(--black-20);
    border-radius: 4px;
    margin-bottom: 5px;
}

.modal.demo .dialog .expando .header {
    height: 40px;
    padding-left: 10px;

    border-top-left-radius: 4px;
    border-top-right-radius: 4px;

    background-color: var(--black-10);

    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal.demo .dialog .expando .header .title {
    font-size: 14px;
    color: var(--black-85);
    font-weight: 500;
}

.modal.demo .dialog .expando .header .expand  {
    font-size: 24px;
    cursor: pointer;
    user-select: none; 
}

.modal.demo > .dialog .expando .body.expanded {
    height: 200px;
}

.modal.demo > .dialog .expando .body {
    height: 0px;
    overflow: auto;
    padding-left: 10px;
    padding-right: 10px;

    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    background-color: var(--black-00);
}

.modal.demo > .dialog .expando .body h1 {
    font-size: 16px;
    color: var(--black-80);
}

.modal.demo > .dialog .expando .body h2 {
    font-size: 14px;
    color: var(--black-80);
}

.modal.demo > .dialog .actions .cta {
    font-size: 15px;
    height: 36px;
}
`, "",{"version":3,"sources":["webpack://./src/demo.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,sBAAsB;IACtB,iCAAiC;IACjC,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;;IAElB,2BAA2B;IAC3B,4BAA4B;;IAE5B,iCAAiC;;IAEjC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,mBAAmB;;IAEnB,8BAA8B;IAC9B,+BAA+B;;IAE/B,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,YAAY;AAChB","sourcesContent":[".modal.demo .dialog {\n    width: 600px;\n    color: var(--black-65);\n    background-color: var(--black-05);\n    gap: 16px;\n}\n\n.modal.demo .dialog > .header {\n    height: 40px;\n    border-bottom: 1px solid var(--black-20);\n}\n\n.modal.demo .dialog > .body {\n    font-size: 13px;\n}\n\n.modal.demo .dialog > .titlebar {\n    font-size: 16px;\n    color: var(--black-80);\n    font-weight: bold;\n}\n\n.modal.demo .dialog .expando {\n    border: 2px solid var(--black-20);\n    border-radius: 4px;\n    margin-bottom: 5px;\n}\n\n.modal.demo .dialog .expando .header {\n    height: 40px;\n    padding-left: 10px;\n\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n\n    background-color: var(--black-10);\n\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.modal.demo .dialog .expando .header .title {\n    font-size: 14px;\n    color: var(--black-85);\n    font-weight: 500;\n}\n\n.modal.demo .dialog .expando .header .expand  {\n    font-size: 24px;\n    cursor: pointer;\n    user-select: none; \n}\n\n.modal.demo > .dialog .expando .body.expanded {\n    height: 200px;\n}\n\n.modal.demo > .dialog .expando .body {\n    height: 0px;\n    overflow: auto;\n    padding-left: 10px;\n    padding-right: 10px;\n\n    border-bottom-left-radius: 4px;\n    border-bottom-right-radius: 4px;\n\n    background-color: var(--black-00);\n}\n\n.modal.demo > .dialog .expando .body h1 {\n    font-size: 16px;\n    color: var(--black-80);\n}\n\n.modal.demo > .dialog .expando .body h2 {\n    font-size: 14px;\n    color: var(--black-80);\n}\n\n.modal.demo > .dialog .actions .cta {\n    font-size: 15px;\n    height: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
